import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { cliente, PcrcApiService } from "../../api/pcrc-api.service";
import { UserApiService } from "../../api/user-api.service";
import { StateService } from "../../services/state.service";
import { googleAnalytics } from "../../services/googleAnalytics.service";
import { AutenticateApiService } from "../../api/autenticate-api.service";
@Component({
  selector: 'app-side-sheet',
  templateUrl: './side-sheet.component.html',
  styleUrls: ['./side-sheet.component.css']
})
export class SideSheetComponent implements OnInit {

  public clientes: cliente[];
  public clienteSeleccionado: cliente;
  public pcrcSeleccionado: cliente['pcrcs'][0];
  public userName: string;
  public rol: string;
  public userPcrc$: Observable<cliente[]>;
  public changePcrc: boolean;
  public logoutLoading = false;
  public permisoCopiarLoading = false;
  validarpcrc
  
  constructor(
    public router: Router,
    private PcrcApiService: PcrcApiService,
    public state: StateService,
    public googleAnalytics: googleAnalytics,
    public autenticateApi: AutenticateApiService,
    public userApiService:UserApiService
  ) { }

  ngOnInit() {
    this.userName = this.state.getValueOf('user').name
    this.rol = this.state.getValueOf('user').rol 

      let data={
            cedula:this.state.getValueOf('user').sub
        }

        this.userApiService.validarPcrc(data).subscribe(data=>{

            if(data!=0){
              this.validarpcrc=true
            }else{
              this.validarpcrc=false
            }

    })

  }
  changeCliente(cliente: cliente) {
   
    this.googleAnalytics.setDimension(1, 'cliente', cliente.cliente)
    this.state.newSelectedCliente(cliente)
  }
  changeSubLine(pcrc: cliente['pcrcs'][0]) {
    this.googleAnalytics.setDimension(2, 'pcrc', pcrc.pcrc)
    this.state.newSelectedPcrc(pcrc)
  }

  onPcrcSeleccionado(cliente: cliente) {

    localStorage.setItem('selectedClienteId', cliente.id_dp_clientes.toString())
    localStorage.setItem('selectedPcrcId', cliente.pcrcs[0].id_dp_pcrc.toString())

    this.state.newSelectedPcrc(cliente.pcrcs[0])
    this.state.newSelectedCliente(cliente)
   
  }

  logOut = () => {
    try {
      localStorage.removeItem('selectedClienteId')
      localStorage.removeItem('selectedPcrcId')
      this.logoutLoading = true;
      this.autenticateApi.logOut()
      this.router.navigate(['/'])
    } catch (error) {
      console.log(error)
    }
  }

  cambiarProteccionDeDatos(){
    this.permisoCopiarLoading = true;
    this.PcrcApiService.putPermisoCopiado(this.state.getValueOf('selectedPcrc').id_dp_pcrc.toString()).pipe(
      tap(result => {
        this.permisoCopiarLoading = false;
        this.state.cambiarProteccionDeDatos(result.puede_copiar)
      })
    ).subscribe()
  }

  explorer(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/explore'])
  }

  new(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/news'])
  }

  favorite(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/favorites'])
  }

  edicion(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/edicion'])
  }

  newseditor(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/newseditor'])
  }

  users(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/users'])
  }

  reports(){
    this.autenticateApi.refreshToken().subscribe()
    console.log('ok')
    this.router.navigate(['/app/reports'])
  }

  bases(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/bases'])
  }

  permisos(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/permisos'])
  }

  papeleria(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/papeleria-reciclaje'])
  }

  usuarios(){
    this.autenticateApi.refreshToken().subscribe()
    this.router.navigate(['/app/usuarios'])
  }



}